import React from 'react';
import { useMsal } from '@azure/msal-react';
import './Login.css';
import config from '../../config/config';

// Renders a button which, when selected, will redirect the page to the logout prompt
const SignOutButton = () => {
  async function handleLogout(instance) {
    await instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
    config.saveToken('');
  }

  const { instance } = useMsal();

  return (
    <button className='btn' onClick={() => handleLogout(instance)}>
      Sign out
    </button>
  );
};

export default SignOutButton;
